export const VISIT_HISTORY_TITLE = 'Visit History';
export const VISIT_HISTORY_HELPER = 'Most visits';
export const VISIT_HISTORY_EMPTY_LABEL = 'No visits recorded';
export const VISIT_HISTORY_MIN_BAR_HEIGHT = 14;
